
(function () {
  if (window.tlccWhatsAppReady) return;
  window.tlccWhatsAppReady = true;

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('#tlcc-whatsapp-order');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const summary =
      button.closest('.cart-drawer__summary') ||
      button.closest('cart-drawer') ||
      button.parentElement.parentElement;

    const phone = summary.querySelector('#tlcc-whatsapp-number');
    const email = summary.querySelector('#tlcc-email');

    // Check contact fields exist
    if (!phone || !email) {
      alert('Please enter your contact details.');
      return;
    }

    // Validate WhatsApp number
    if (!/^[0-9]{10}$/.test(phone.value.trim())) {
      phone.setCustomValidity('Please enter exactly 10 digits.');
      phone.reportValidity();
      phone.setCustomValidity('');
      phone.focus();
      return;
    }

    // Validate email address
    if (!email.value.trim() || !email.checkValidity()) {
      email.setCustomValidity(
        email.value.trim()
          ? 'Please enter a valid email address.'
          : 'Please enter your email address.'
      );
      email.reportValidity();
      email.setCustomValidity('');
      email.focus();
      return;
    }

    // Collect delivery details
    const deliveryFields = [
      ['Name', '#tlcc-full-name'],
      ['Address', '#tlcc-address'],
      ['Area / Landmark', '#tlcc-area'],
      ['City', '#tlcc-city'],
      ['State', '#tlcc-state'],
      ['PIN Code', '#tlcc-pincode']
    ];

    const deliveryDetails = [];

    for (const [label, selector] of deliveryFields) {
      const field = summary.querySelector(selector);

      if (!field) {
        alert(
          'Delivery details are unavailable. Please refresh the cart.'
        );
        return;
      }

      const value = field.value.trim();

      // Area / Landmark is optional
      if (selector !== '#tlcc-area' && !value) {
        field.setCustomValidity(
          `Please enter your ${label.toLowerCase()}.`
        );
        field.reportValidity();
        field.setCustomValidity('');
        field.focus();
        return;
      }

      // Validate Indian PIN code
      if (
        selector === '#tlcc-pincode' &&
        !/^[0-9]{6}$/.test(value)
      ) {
        field.setCustomValidity(
          'Please enter a valid 6-digit PIN code.'
        );
        field.reportValidity();
        field.setCustomValidity('');
        field.focus();
        return;
      }

      if (value) {
        deliveryDetails.push(`${label}: ${value}`);
      }
    }

    // Open WhatsApp tab immediately to avoid popup blocking
    const whatsappTab = window.open('', '_blank');

    button.disabled = true;

    try {
      // Fetch latest Shopify cart
      const response = await fetch(
        window.Shopify.routes.root + 'cart.js',
        { credentials: 'same-origin' }
      );

      if (!response.ok) {
        throw new Error('Unable to load cart');
      }

      const cart = await response.json();

      if (!cart.items || !cart.items.length) {
        if (whatsappTab) whatsappTab.close();
        alert('Your cart is empty.');
        return;
      }

      // Format INR amounts
      const money = value =>
        '₹' + (value / 100).toFixed(2);

      // Shipping calculated after discounts
      const shipping =
        cart.total_price >= 50000 ? 0 : 6000;

      // Prepare WhatsApp message
      const message = [
        'Hello The Little Champs Club! ♡',
        '',
        'I would like to place an order:',
        ''
      ];

      // Add cart products
      cart.items.forEach((item, index) => {
        message.push(
          `${index + 1}. ${item.product_title}` +
          (
            item.variant_title &&
            item.variant_title !== 'Default Title'
              ? ` - ${item.variant_title}`
              : ''
          ),
          `Quantity: ${item.quantity}`,
          `Price: ${money(item.final_line_price)}`,
          ''
        );
      });

      // Add totals, contact and delivery details
      message.push(
        `Product Subtotal: ${money(cart.total_price)}`,
        `Shipping: ${
          shipping === 0 ? 'FREE' : money(shipping)
        }`,
        `Estimated Total: ${
          money(cart.total_price + shipping)
        }`,
        '',
        'Customer Contact Details:',
        `WhatsApp: +91 ${phone.value.trim()}`,
        `Email: ${email.value.trim()}`,
        '',
        'Delivery Details:',
        ...deliveryDetails,
        '',
        'All my contact and delivery details are shared above.',
        'Please share the UPI payment details to complete my order.',
        'I understand my order will be processed after payment verification.'
      );

      // Open WhatsApp with complete order information
      const whatsappUrl =
        'https://wa.me/917845320360?text=' +
        encodeURIComponent(message.join('\n'));

      if (whatsappTab) {
        whatsappTab.location.href = whatsappUrl;
      } else {
        window.location.href = whatsappUrl;
      }

    } catch (error) {
      if (whatsappTab) whatsappTab.close();

      alert(
        'Could not prepare your order. Please try again.'
      );
    } finally {
      button.disabled = false;
    }
  });
})();
